import React, { useState, useContext, useEffect } from "react";
import CommonTable from "../../custom-components/CommonTestCasesTable";
import { Box, Typography, Button, Divider, Radio, RadioGroup, FormControlLabel } from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { ReactComponent as DownloadIcon } from "../../../images/DownloadIcon.svg";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { useNavigate, useLocation } from "react-router-dom";
import CommonDownload from "../../custom-components/CommonDownload";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import { APITraceabilityMatrix } from "../../../services/webServices";

function TestCasesforApiTesting(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [nextButton, setNextButton] = useState(false);
  const [RTMnextButton, setRTMnextButton] = useState(false);
  const [downloadRTMOpen, setDownloadRTMOpen] = useState(false);
  const [downloadType, setDownloadType] = useState("");
  const [buttontype, setButtonType] = useState("");
  const [testCases, setTestCases] = useState(props.generateTestCasesData);
  const [apiDocData, setApiDocData] = useState("");
  const [traceabilityMatrixData, setTraceabilityMatrixData] = useState({})
  const [testOption, setTestOption] = useState("");
  const defaultLocatorsExpanded =
    props.generateTestCasesData.length > 0 &&
    Object.keys(location.state?.configurationData || {}).length == 0;

  // const headers = Object.keys(testCases[0]);
  // const values = testCases.map((testCase) =>
  //   headers.map((header) => testCase[header])
  // );

  const headers = Object.keys(testCases[0]);
  const values = testCases.map((testCase) =>
    headers.map((header) => {
      const cell = testCase[header];
      return typeof cell === 'object' && cell !== null
        ? JSON.stringify(cell)
        : cell;
    })
  );

  useEffect(() => {
    setTestCases(location.state?.generateTestCasesData);
    setButtonType(location.state?.button);
    setTraceabilityMatrixData(location.state?.traceabilityMatrix)
    setApiDocData(location.state?.apiDocData);
  }, [location.state]);

  const tableDataConverter = (testCases) => {
    const headers = Object.keys(testCases[0]);
    const values = testCases.map((eachTestCase) => {
      return Object.values(eachTestCase);
    });
    return { headers, values };
  };

  const formattedTestCases = [];
  testCases.map((testCase) => {
    const flattenTestCase = {};
    Object.entries(testCase).map(([key, value]) => {
      if (Array.isArray(value)) {
        return (flattenTestCase[key] = flattenArray(value));
      } else if (typeof value === "object" && !!value) {
        return (flattenTestCase[key] = flattenObject(value));
      } else {
        return (flattenTestCase[key] = value);
      }
    });
    return formattedTestCases.push(flattenTestCase);
  });

  const generateConfig = (testOption) => {

    if (testOption === "New Test Design") {
      navigate("/dashboard/api-testing/manual", {
        state: {
          clearFileData: true,
        }
      });
    }
    else if (testOption === "Test Automation") {

      navigate("/dashboard/api-testing/choose-testcase", {
        state: { testCaseData: testCases },
      });
    }
  };

  //  const handleNextClick = () => {
  //   generateConfig(testOption);
  // };

  const handleNextClick = () => {
    navigate("/dashboard/api-testing/flow-selection", { replace: true });
  }

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };
  const handleDownloadClick = () => {
    setDownloadOpen(true);
    // setNextButton(true);
  };

  const handleTraceabilityMatrix = () => {
    setDownloadRTMOpen(true);
    // setRTMnextButton(true);
  }

  const handleCloseTraceabilityMatrix = () => {
    setDownloadRTMOpen(false)
    // setRTMnextButton(false)
  }
  const formatTestPlan = (testPlanData) => {
    const formattedTestPlan = {};
    Object.entries(testPlanData).map(([key, value]) => {
      if (Array.isArray(value)) {
        return (formattedTestPlan[key] = flattenArray(value));
      }
      if (!!value && typeof value === "object") {
        return (formattedTestPlan[key] = flattenObject(value));
      }
      return (formattedTestPlan[key] = value);
    });
    // console.log(formattedTestPlan)
    return formattedTestPlan;
  };


  const handleTracabilityMatrixData = (traceabilityMatrixData) => {
    const headers = [
      "Requirement ID",
      "Test Conditions Summary",
      "Test Case ID(s)",
    ];

    const values = [];
    Object.entries(traceabilityMatrixData).map(([key, value]) => {
      if (key === "Summary of Findings") return;
      if (Array.isArray(value)) {
        value.map((eachTrace) => {
          const requirementId = eachTrace["Requirement ID"] || "";
          const testConditionId = eachTrace["Test Conditions Summary"] || "";
          const testCaseIds = (eachTrace["Test Case ID(s)"] || [])
            .map((testCase) => testCase["Test Case ID"] || "")
            .join(", ");
          return values.push([
            requirementId,
            testConditionId,
            testCaseIds,
          ]);
        });
      } else {
        console.error(`Expected an array but got: ${typeof value}`, value);
      }
    });

    return { headers, values };
  };

  const handleSummaryOfFindings = (traceabilityMatrixData) => {
    const summaryOfFindings =
      traceabilityMatrixData["Summary of Findings"] || {};
    const uncoveredRequirements =
      summaryOfFindings["Uncovered Requirements"] || [];
    const redundantTestCases = summaryOfFindings["Redundant Test Cases"] || [];
    const summaryData = [];
    if (uncoveredRequirements.length > 0) {
      summaryData.push(
        `\nUNCOVERED REQUIREMENTS:\n\n${uncoveredRequirements
          .map((eachRequirement) => {
            return `Requirement ID: ${eachRequirement["Requirement ID"]}\nDescription: ${eachRequirement["Description"]}\n`;
          })
          .join("\n")}`
      );
    }
    if (redundantTestCases.length > 0) {
      summaryData.push(
        `\nREDUNDANT TEST CASES:\n${redundantTestCases
          .map((eachTestCase) => {
            return `Test Case ID: ${eachTestCase["Test Case ID"]}\nDescription: ${eachTestCase["Description"]}`;
          })
          .join("\n")}`
      );
    }

    return summaryData.join("\n");
  };

  const apiTestDesignControls = (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"

      sx={{ width: "100%" }}
    >
      {/* <RadioGroup
        row
        value={testOption}
        onChange={(e) => setTestOption(e.target.value)}
        sx={{ display: "flex", gap: 2 }}
      >
        <FormControlLabel
          value="New Test Design"
          control={
            <Radio
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 14,
                },
              }}
            />
          }
          label="New Test Design"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "14px",
            },
          }}
        />

        <FormControlLabel
          value="Test Automation"
          control={
            <Radio
            
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 14,
                },
              }}
            />
          }
          label="Test Automation"
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: "14px",
            },
          }}
        />
      </RadioGroup> */}

      {/* <Button
        variant="contained"
        onClick={handleNextClick}
        sx={{
          textTransform: "none",
          fontSize: 14,
          backgroundColor: "#49A3FF",
          whiteSpace: "nowrap",
        }}
        // disabled={!testOption} // Disable if no option is selected
      >
        Next
      </Button> */}
      {nextButton && RTMnextButton && (
        <Button
          variant="contained"
          onClick={handleNextClick}
          sx={{
            textTransform: "none",
            fontSize: 14,
            backgroundColor: "#49A3FF",
            whiteSpace: "nowrap",
          }}
        >
          Finish
        </Button>
      )
      }
      {/* <Button
        variant="contained"
        onClick={handleNextClick}
        sx={{
          textTransform: "none",
          fontSize: 14,
          backgroundColor: "#49A3FF",
          whiteSpace: "nowrap",
        }}
      disabled={!nextButton} // Disable if no option is selected
      >
        API Testing Landing page
      </Button> */}
    </Box>
  );



  const functionalTestCasesCount = formattedTestCases.filter((test) =>
    test["Test Case ID"].startsWith("TCD_FT")
  ).length;
  const nonFunctionalTestCasesCount = formattedTestCases.filter((test) =>
    test["Test Case ID"].startsWith("TCD_NFT")
  ).length;
  //const functionalTestCasesCount = testCases.
  const totalTestCasesCount =
    functionalTestCasesCount + nonFunctionalTestCasesCount;


  const buttonsgroup = [
    {
      label: "Download",
      onClick: handleDownloadClick,
      variant: "text",
      startIcon: <DownloadIcon />,
    },
    {
      label: "RTM",
      onClick: handleTraceabilityMatrix,
      variant: "text",
      startIcon: <DownloadIcon />,
    },
    // {
    //   sx: { float: "right" },
    //   label: "Configure Test Automation",
    //   variant: "contained",
    //   onClick: generateConfig,
    //   //  disabled : true,
    //   startIcon: <GenerateButton />,
    // },
    {
      label: apiTestDesignControls,
      // onClick: () => {}, // required placeholder
      variant: "text",
      // sx: { padding: 0, minWidth: 0 },
      sx: {
        textTransform: "none",
        cursor: "default",
        "&.Mui-disabled": {
          color: "black", // Prevents graying out
          opacity: 1, // Restores normal opacity
        },
        float: "right"
        // "&:hover": {
        //   backgroundColor: "transparent",
        // },
        // "&:active": {
        //   backgroundColor: "transparent",
        // },
      },
    },

  ];

  return (
    <Box>
      <CommonAccordion
        summary={"Test Cases"}
        details={
          <>
            {/* Add a Typography component above the table */}
            <Typography variant="subtitle1" sx={{ fontSize: 15, mb: 2 }}>
              Test Cases
            </Typography>

            <CommonTable
              headers={headers}
              values={values}
              edittable={true}
              tableData={testCases}
              setTableData={setTestCases}
            />
            <Box display="flex" gap={4} alignItems="center" mt={2.5} mb={2}>
              <Typography sx={{ fontSize: 14 }} variant="body1">
                Functional test cases: {functionalTestCasesCount}
              </Typography>
              <Typography sx={{ fontSize: 14 }} variant="body1">
                Non Functional test cases: {nonFunctionalTestCasesCount}
              </Typography>
              <Typography sx={{ fontSize: 14 }} variant="body1">
                Total test cases: {totalTestCasesCount}
              </Typography>
            </Box>
          </>
        }
        type={"output"}
        defaultExpanded={defaultLocatorsExpanded}
        buttons={buttonsgroup}
        fullScreenMode={true}
      />

      <CommonDownload
        open={downloadOpen}
        onClose={() => setDownloadOpen(false)}
        onDownloadSuccess={() => {
          setNextButton(true);
          setDownloadOpen(false);
        }}
        onCancel={() => {
          setNextButton(false);
          setDownloadOpen(false);
        }}
        serviceResponse={[formattedTestCases]}
        serviceName="TestCases_Report"
        wordData={[
          {
            heading: "Test Cases",
            type: "table",
            data: { ...tableDataConverter(formattedTestCases) },
          },
        ]}
        documents={["xls", "csv"]}
      />
      <CommonDownload
        open={downloadRTMOpen}
        onClose={()=> setDownloadRTMOpen(false)}
        onDownloadSuccess={() => {
          setRTMnextButton(true);
          setDownloadOpen(false);
        }}
        onCancel={() => {
          setRTMnextButton(false);
          setDownloadOpen(false);
        }}
        serviceResponse={[
          {
            heading: "Requirement Traceability Matrix",
            type: "table",
            data: handleTracabilityMatrixData(traceabilityMatrixData),
          },
          {
            heading: "Summary of Findings",
            type: "text",
            data: handleSummaryOfFindings(traceabilityMatrixData),
          },
        ]}
        serviceName="Requirement Traceability Matrix"
        wordData={[
          {
            heading: "Requirement Traceability Matrix",
            type: "table",
            data: handleTracabilityMatrixData(traceabilityMatrixData),
          },
          {
            heading: "Summary of Findings",
            type: "text",
            data: handleSummaryOfFindings(traceabilityMatrixData),
          },
        ]}
        documents={["docx", "pdf"] || []}
      />
    </Box>
  );
}

export default TestCasesforApiTesting;
